theme.alinga = theme.alinga || {};
theme.alinga.mobilemenu = () => {
 let listOrders = document.querySelectorAll('.nav-container ul>li')
	listOrders.forEach((liEle)=>{
  	let ele = liEle.classList.contains('has-children');
    if( ele == 'false')
    liEle.classList.add('button alt large');
	});
};
theme.alinga.brandWithText = () => {
  let iconBoxes = document.querySelectorAll('.logo-box');
  iconBoxes.forEach(icon => {
    icon.addEventListener('mouseover', (e) => {
      let tabId = e.currentTarget.getAttribute('data-tab');
      let iconContent = document.querySelectorAll('.index_brand_slider_content .logo-sub-text');
      iconBoxes.forEach(boxes => {
        boxes.classList.remove('active');
      })
      iconContent.forEach(content => {
        content.classList.remove('active');
      })
      e.currentTarget.classList.add('active');
      document.querySelector(`#${tabId}`).classList.add('active');
    })
  })

  const indexLogoSlider = new Swiper("#indexLogoBar", {
    slidesPerView: 5,
    spaceBetween: 40,
    loop:false,
    breakpoints: {
      768: {
        slidesPerView: 2,
        centeredSlides: true,
        spaceBetween: 40
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 40
      }
    }
  })
  if (window.innerWidth < 768) {
  indexLogoSlider.on('slideChange', () => {
        let currIndex = indexLogoSlider.activeIndex;
        let currentIndex = currIndex + 1;
  		let logo = document.querySelectorAll('.index_logo__item .logo-box');
         logo.forEach(logoval => {
          let logoValue = logoval.getAttribute('data-tab')
          const lgoNumvalue = logoValue.split('-');
          const logoIndex =  lgoNumvalue[2];
           if( currentIndex == logoIndex ){
             logoval.classList.add('active');
           }
           else{
             logoval.classList.remove('active');
           }
         })
         let logoContent = document.querySelectorAll('.index_brand_slider_content .logo-sub-text');
        logoContent.forEach(content => {
          let idValue = content.getAttribute('id')
          const numvalue = idValue.split('-');
          const idIndex =  numvalue[2];
          if( currentIndex == idIndex )
            {
              content.classList.add('active');
            }
          else{
            content.classList.remove('active');
          }
          })
      });
  }
}
theme.alinga.footer = () => {
  let footerTitles = document.querySelectorAll('.section-footer__menu-block .section-footer__title');
  footerTitles.forEach(title => {
    title.addEventListener('click', (e) => {
      e.currentTarget.classList.toggle('active');
      e.currentTarget.nextElementSibling.classList.toggle('active');
    })
  })
}
theme.alinga.equalHeight = ($ele) => {
  let cacheHeight = 0;
  setTimeout(() => {
    let ele = document.querySelectorAll($ele);
    ele.forEach(element => {
      (element.clientHeight > cacheHeight) ? cacheHeight = element.clientHeight : cacheHeight = cacheHeight;
    });
    ele.forEach(element => {
      element.style.height = `${cacheHeight}px`
    })
  }, 300);
}
theme.alinga.equalHeightpdp = ($elepdp) => {
  let cacheHeight = 0;
  setTimeout(() => {
    let ele = document.querySelectorAll($elepdp);
    ele.forEach(element => {
      (element.clientHeight > cacheHeight) ? cacheHeight = element.clientHeight : cacheHeight = cacheHeight;
    });
    ele.forEach(element => {
      element.style.height = `${cacheHeight}px`
    })
  }, 10000);
}
theme.alinga.productBlockATC = () => {
  let varians = document.querySelectorAll('.block-swatches a');
  varians.forEach(btn => {
    setTimeout(() => {
      btn.addEventListener('click', (e) => {
        let currId = e.currentTarget.getAttribute('data-id');
        e.preventDefault();
        varians.forEach(btn => btn.classList.remove('selected'));
        e.currentTarget.classList.add('selected');
        let formIdEle = e.currentTarget.closest('.product-block__inner').querySelector('[name="id"]');
        formIdEle.value = currId;
      })
    }, 10000);
  }); 
  let swatchTrigger = document.querySelectorAll('.show-swatch-color');
  swatchTrigger.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.currentTarget.closest('.form').previousElementSibling.classList.add('active')
    })
  });
  let swatchCloseBtn = document.querySelectorAll('.swatch-pop-data .close-wraper .close-modal');
  swatchCloseBtn.forEach(close => {
    close.addEventListener('click', (e) => {
      e.currentTarget.closest('.swatch-pop-data').classList.remove('active');
    })
  });
  setTimeout(() => {
    let varians = document.querySelectorAll('.block-swatches a');
    varians.forEach(btn => {
        btn.addEventListener('click', (e) => {
          let currId = e.currentTarget.getAttribute('data-id');
          e.preventDefault();
          varians.forEach(btn => btn.classList.remove('selected'));
          e.currentTarget.classList.add('selected');
          let formIdEle = e.currentTarget.closest('.product-block__inner').querySelector('[name="id"]');
          formIdEle.value = currId;
        })
    }); 
    let swatchTriggerPDP = document.querySelectorAll('.show-swatch-color');
    swatchTriggerPDP.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.currentTarget.closest('.form').previousElementSibling.classList.add('active')
    })
  	});

    let swatchCloseBtnPDP = document.querySelectorAll('.swatch-pop-data .close-wraper .close-modal');
    swatchCloseBtnPDP.forEach(close => {
      close.addEventListener('click', (e) => {
        e.currentTarget.closest('.swatch-pop-data').classList.remove('active');
      })
    });
  }, 10000);
  let svgCheck = `<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"></path><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path></svg>`;
  let productCards = document.querySelectorAll('.product--block form');
  productCards.forEach(form => {
    form.addEventListener('submit', (e) => {
      formBtn = e.currentTarget.querySelector('.button');
      formBtn.classList.add('confirmation');
      formBtn.innerHTML = `${svgCheck} Adding`;
      e.preventDefault();
      let formData = new FormData(form);
      data = {
        quantity:1,
        id: formData.get('id')
      }
      fetch('/cart/add.js',{
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
      .then(data => {
        theme.alinga.updateCartQuantity(formData.get('id'));
        formBtn.innerHTML = `${svgCheck} Added To Card`;
        setInterval(() => {
          formBtn.classList.remove('confirmation');
          formBtn.innerHTML = 'Add To Cart';  
        }, 2000);
      })
      .catch(error => console.log(error))
    })
  });
  
  theme.alinga.updateCartQuantity = ($id) => {
    fetch('/cart.js',{
      method:'GET'
    })
    .then(response => response.json())
    .then(data => {
      document.querySelector('.nav-right-side .cart div').innerHTML = data.item_count;
      let items = data.items;
      let modalData = null;
      items.map(resData => {
        if (resData.id == $id) {
          modalData = resData;
        }
      })
      var offset = 25;
      var nav = theme.Nav();
      if (nav.bar.getPositionSetting() !== "inline") {
        offset = nav.bar.height();
      }
      // let variantHtml = '';
      // if (modalData.options_with_values && modalData.options_with_values.length) {
      //   for (var _i2 = 0; _i2 < modalData.options_with_values.length; _i2++) {
      //     var option = modalData.options_with_values[_i2];
      //     if (option.name !== "Title" && option.value !== "Default Title") {
      //       variantHtml += "<p class=\"cart-product__content__meta\">".concat(option.name, ": ").concat(option.value, "</p>");
      //     }
      //   }
      // }
      // let modalHtml = `<div id="added-to-cart" class="theme-modal theme-modal--small" role="dialog" aria-modal="true" aria-labelledby="added-to-cart-title">
      // <div class="inner" style="top:${offset}px">
      // <a href="#" data-modal-close="" class="modal-close">&times;</a>
      // <h4 id="added-to-cart-title"><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"></path><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path></svg>Added to cart</h4>
      // <div class="cart-product">
      // <div class="cart-product__image">
      // <img src="${modalData.featured_image.url}" alt="${modalData.featured_image.alt}"></div>
      // <div class="cart-product__content">
      // <p class="cart-product__content__title">${modalData.product_title}</p>
      // <p class="cart-product__content__price"><span class="current-price theme-money"> $${modalData.price / 100 }</span></p>
      // ${variantHtml}
      // </div>
      // </div>
      // <p class="links links--no-checkout">
      // <a href="/cart" class="button ">View cart</a>
      // <a href="/checkout" class="button button--checkout" [data-cc-checkout-button]="">Checkout</a> 
      // </p>
      // </div>
      // </div>`;
      // let bodyEle = document.querySelector('body');
      // bodyEle.classList.add('modal-active');
      // bodyEle.insertAdjacentHTML('beforeend', modalHtml);
      // setTimeout(() => {
      //   document.querySelector('#added-to-cart').classList.add('reveal');
      // }, 20);
      // closeModal();
    })
    // let closeModal = () => {
    //   let closeBtn = document.querySelector('#added-to-cart .modal-close');
    //   closeBtn.addEventListener('click', (e) => {
    //     setTimeout(() => {
    //       document.querySelector('#added-to-cart.theme-modal').remove();
    //     }, 250); 
    //   })
    // }
  }
}
theme.alinga.custTestimonialSlider = () => {
 const reviewSliderImg = new Swiper("#testimoNialImgSlider", {
    slidesPerView: 1,
    loop: true,
    effect: 'fade',
    speed:500,
    autoplay: {
      delay: 3000,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  })
  const reviewSlider = new Swiper("#reviewsSlider", {
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 3000,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 1,
        autoplay: {
          delay: 3000,
        },
        loop:true
      },
      1024: {
        slidesPerView: 1,
        autoplay: {
          delay: 3000,
        },
      }
    }
  });
  reviewSliderImg.on('slideChange', () => {
    let currIndex = reviewSliderImg.activeIndex;
    reviewSlider.slideTo(currIndex)
  });
  reviewSlider.on('slideChange', () => {
    let currIndex = reviewSlider.activeIndex;
    reviewSliderImg.slideTo(currIndex)
  });
} 
theme.alinga.homepageBannerSlider = () => {
  const bannerSliderImg = new Swiper("#bannerImageSlider", {
    slidesPerView: 1,
    effect: 'fade',
    speed:500,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoplay: {
      delay: 5000,
    },
  })
  const textSlider = new Swiper("#textSlider", {
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoplay: {
      delay: 5000,
    },
    breakpoints: {
      768: {
        slidesPerView: 1,
        autoplay: {
          delay: 5000,
        },
      },
      1024: {
        slidesPerView: 1,
        autoplay: {
          delay: 5000,
        },
      }
    }
  });
  bannerSliderImg.on('slideChange', () => {
    let currIndex = bannerSliderImg.activeIndex;
    textSlider.slideTo(currIndex)
  });
  textSlider.on('slideChange', () => {
    let currIndex = textSlider.activeIndex;
    bannerSliderImg.slideTo(currIndex)
  });
}

theme.alinga.custBundleSection = () => {
  let videoCard =  document.querySelectorAll('.video-bundle .img-wrapper');
  videoCard.forEach(ele => {
    ele.addEventListener('click', (e) => {
      let videoLink = e.currentTarget.getAttribute('data-videolink');
      let headerLogo = document.querySelector('.logo').outerHTML;
      let headerText = e.currentTarget.nextElementSibling.textContent;
      let modelHtml = `<div class="model-index-bundle" id="cust-video-bundle"><div class="wide-container"><div class="modal-header">${headerLogo}<span class="title">${headerText}</span><div class="close-pop-wrapper"><span class="close-model">&times;</span></div></div><div class="model-body"><div class="model-content">${videoLink}</div></div></div></div>`;
      document.querySelector('body').insertAdjacentHTML('beforeend',modelHtml);
      setTimeout(() => {
        document.querySelector('#cust-video-bundle').classList.add('active');
      }, 100);
      closeModel();
    })
  });
  const closeModel = () => {
    let triggerBtn = document.querySelector('.model-index-bundle .close-model');
    triggerBtn.addEventListener('click', (e) => {
      let modelDiv = document.querySelector('#cust-video-bundle');
      modelDiv.classList.remove('active');
      setTimeout(() => {
        modelDiv.remove();
      }, 100);
    })
  }
}

theme.alinga.pdpDeskGallery = () => {
  const pdpDeskSlider = new Swiper('.product-slider.cust-slider .slieder-imgs', {
    observer: true,
    observeParents: true,
    autoHeight:true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });
  setTimeout(() => {
    let GalleryImages = document.querySelectorAll('.product-slider.cust-slider .slieder-imgs .swiper-slide');
    let swatchTrigger = document.querySelectorAll('.option--color a');
    swatchTrigger.forEach(swatch => {
      swatch.addEventListener('click', (e) => {
        let imgId = e.currentTarget.getAttribute('data-value');
        GalleryImages.forEach(img => {
          let imgAlt = img.querySelector('img').getAttribute('alt');
          if (imgAlt == imgId) {
            img.style.display = 'block'
          }else {
            img.style.display = 'none'
          }
        })
        pdpDeskSlider.slideTo(0);
      })
    })
  }, 250);
}
theme.alinga.threeDGallery = () => {
  let AllImages = document.querySelectorAll('.gtn-3dgrid-main-wrapper .gtn-content-wrapper .gtn-block-wrapper');
  document.addEventListener('mousemove', (e) => {
    let X = -(e.clientX - window.innerWidth);
    let Y = -(e.clientY - window.innerHeight);
    for (let i = 0; i < AllImages.length; i++) {
      const img = AllImages[i];
      let rotateX = (e.clientY / (window.innerWidth / 25)) - ((Y / (window.innerWidth / 25)));
      let rotateY = (e.clientX / (window.innerWidth / 25)) - ((X / (window.innerWidth / 25)));
      
      img.style.transform = `translate3d(${(Math.floor(Math.random() * ((X-200) - X + 1) + X) * 2 - window.innerWidth) / 50}px,
      ${- (Math.floor(Math.random() * ((Y-200) - Y + 1) + Y) * -2 - window.innerWidth) / 50}px, 0)
      rotateY(${rotateY}deg) rotateX(${rotateX}deg)`;
      let cursorText = document.querySelector('.cursor__text');
      let cursorCircle = document.querySelector('.cursor');
      if (cursorCircle) {
        cursorCircle.style.transform = `translate(${e.clientX - 23}px,${e.clientY - 23}px)`;
        if (e.target.classList.contains('gtn-block-wrapper')) {
          e.target.classList.add('selected');
          let title = e.target.getAttribute('data-title');
          if (window.innerWidth >= 768) {
            cursorText.textContent = title;
            cursorText.style.opacity = 1;
          }
        } else {
          for (let i = 0; i < AllImages.length; i++) {
            AllImages[i].classList.remove('selected');
          }
          if (window.innerWidth >= 768) {
            cursorText.style.opacity = 0;
          }
        }
      }
    }
  });
  
  AllImages.forEach(btn => {
    btn.addEventListener('click', (e) => {
      let tragetId = e.currentTarget.getAttribute('data-id');
      let targetEle = document.querySelector(`#${tragetId}`);
      e.currentTarget.classList.remove('selected');
      targetEle.classList.add('is-open');
      document.querySelector('.gtn-content-wrapper').classList.add('is-open');
    })
  });
  
  let closeThreeDBtn = document.querySelectorAll('.gtn-3dgrid-main-wrapper .back-layout');
  closeThreeDBtn.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.currentTarget.closest('.gtn-block-wrapper').classList.remove('is-open');
      document.querySelector('.gtn-content-wrapper').classList.remove('is-open');
    });
  });
  
}
theme.alinga.shadePopupData = () => {
  let chatWthUs = () => {
    let chatLink = document.querySelectorAll('a[href="#chatWithUs"]');
    chatLink.forEach(triggerEle => {
      triggerEle.addEventListener('click', (e) => {
        e.preventDefault();

        let ChatBtn = document.querySelector('#ShopifyChat');
        let ChatClass = '.chat-toggle'; 
        if(!ChatBtn){
          ChatBtn = document.querySelector('#dummy-chat-button-iframe');
          ChatClass = '#dummy-chat-button';
        }
        var frame = ChatBtn.contentDocument || ChatBtn.contentWindow.document;
        frame.querySelector(ChatClass).click();
      })
    });
  }
  let onClickCenterSlide = ($trigger) => {
    let trigger = document.querySelectorAll('#fms-slider-wrapper [data-swiper-slide-index]');
    if (window.innerWidth >= 768) {
      trigger.forEach( (slide,index) => {
        slide.addEventListener('click', (e) => {
          let currIndex = index;
          if (window.innerWidth > 1024) {
            currIndex = index - 2;
          }else if(window.innerWidth < 1023) {
            currIndex = index - 1;
          }
          $trigger.slideTo(currIndex);
        })
      });
    }
  }
  
 
  let shadev1Slider = () => { 
    const fmsSlider =  new Swiper("#fms-slider-wrapper", {
      slidesPerView: 12, 
      arrow: true,
      loop:true,
      observer:true,
      observeParents: true,
      breakpoints: {
        768: {
          slidesPerView: "1.3",
          centeredSlides: true,
          arrow: true,
          loop:true
        },
        1024: {
          slidesPerView: 4,
          arrow: true,
          loop:true
        },
        1365: {
          slidesPerView: 7,
          arrow: true,
          loop:true
        }
      }
    });
    onClickCenterSlide(fmsSlider);
  }
   let imgThubSlider = () => {
    new Swiper(".popupdetailSlider.swiper", {
     arrow: true,
     slidesPerView: 1,
     navigation: {
       nextEl: '.swiper-button-next',
       prevEl: '.swiper-button-prev',
     },
     breakpoints: {
       768: {
         slidesPerView: 1,
         arrow: true,
       },
       1024: {
         slidesPerView: 1,
         arrow: true,
       }
     }
   });
 }
  let Shadev1Trigger = document.querySelectorAll('a[href="#shadev1"]');
  let getDataUrl1 = '/pages/find-your-shade?section_id=find-your-shade-new';
  let myShade = document.querySelector('#myShade');
  
  Shadev1Trigger.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      if (myShade.childNodes.length < 1) {
        fetch(getDataUrl1)
        .then(response => response.text())
        .then(data => {
          myShade.innerHTML = `${data}`
          myShade.querySelector('#myShade1').classList.add('active');
          setTimeout(() => { 
            // shadev1Slider();
            closePop('#myShade1 .close-model','#myShade1');
          }, 100);
        });
        let myShadev2 = document.querySelector('#myShadev2');
        let shadev2Url = '/pages/find-your-shade?section_id=fms-details-section';
        if (myShadev2.childNodes.length < 1) {
          fetch(shadev2Url)
          .then(response => response.text())
          .then(data => {
            myShadev2.innerHTML = `${data}`;
            setTimeout(() => {
              if (window.innerWidth < 768) {
                shadev2Pop('#myShade1 .shade-img-wrapper .button');
              }else{
               shadev2Pop('#myShade1 .shade-img-wrapper .button');
              shadev2Pop('#myShade1 .shade-img-wrapper .img-wrapper'); 
              }
              closePop('#myShadev2 .close-model','#myShadev2 .model-index-bundle'); 


              chatWthUs();
//               if (window.innerWidth <= 767) {
//                 imgThubSlider();
//               }
            }, 100);
          })
        }
      }else { 
        document.querySelector('#myShade1').classList.add('active');
      }
    })
  });
  
  let closePop = ($btn,$target) => {
    let closeBtn = document.querySelector($btn);
    closeBtn.addEventListener('click', () => {
      document.querySelector($target).classList.remove('active');
    })
  }
  
  let shadev2Pop = ($triggerValue) => {
    let triggerBtns = document.querySelectorAll($triggerValue);
    triggerBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        
        //       Addtocart code         
        let svgCheck = `<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"></path><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path></svg>`;
        let productCards = document.querySelectorAll('.fms-details-section-popup-form');
        productCards.forEach(form => {
          form.addEventListener('submit', (e) => {
            formBtn = e.currentTarget.querySelector('.fms-details-section-popup-button');
            formBtn.classList.add('confirmation');
            formBtn.innerHTML = `${svgCheck} Adding`;
            e.preventDefault();
            let formData = new FormData(form);
            data = {
              quantity:1,
              id: formData.get('id')
            }
            fetch('/cart/add.js',{
              method: 'POST',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(data)
            })
            .then(data => {
              theme.alinga.updateCartQuantity(formData.get('id'));
              formBtn.innerHTML = `${svgCheck} Added To Card`;
              setInterval(() => {
                formBtn.classList.remove('confirmation');
                formBtn.innerHTML = 'Add To Cart';  
              }, 2000);
            })
            .catch(error => console.log(error))
          })
        });
		//       Addtocart code
        
        let targetId = e.currentTarget.getAttribute('data-target-pop');
        let shadev2Eles = document.querySelectorAll('#myShadev2 .model-shade-detail');
        shadev2Eles.forEach(ele => {
          if (ele.getAttribute('data-model') == targetId) {
            ele.classList.add('active');
          }else {
            ele.classList.remove('active'); 
          }
        })
        document.querySelector('#myShadev2 .model-index-bundle').classList.add('active');
        imgThubSlider();
      })
    });
  }
  
}
theme.alinga.productGallery = () => {
//   let pMedia = document.querySelector('.product-area__media');
  let insertMediaTo = document.querySelector('#MobileGallery');
  if (window.innerWidth <= 767 && insertMediaTo) {
    function insertAfter(newNode, existingNode) {
      existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
    }
    insertAfter(pMedia, insertMediaTo);
  }
}
theme.alinga.shadepopv2slider = () => {
  const popupDetailSlider = new Swiper("#popupDetailSlider", {
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 3000,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 1,
        autoplay: {
          delay: 3000,
        },
        loop:true
      },
      1024: {
        slidesPerView: 1,
        autoplay: {
          delay: 3000,
        },
      }
    }
  });
} 

theme.alinga.readMoreLess = () => {
  let readmore = document.querySelector('.readmore');
  if(readmore) {
  readmore.addEventListener('click', () => {
    event.preventDefault();
    let descriptionFull = document.querySelector('.read-more');
    descriptionFull.style.display = 'block';
    let descriptionShort = document.querySelector('.read-less');
    descriptionShort.style.display = 'none';
  });  
  }
  

  let readless = document.querySelector('.readless');
  if(readless) {
  readless.addEventListener('click', () => {
    event.preventDefault();
    let descriptionFull = document.querySelector('.read-more');
    descriptionFull.style.display = 'none';
    let descriptionShort = document.querySelector('.read-less');
    descriptionShort.style.display = 'block';
  });  
  }
  
}

    
// init function on ready
document.addEventListener('DOMContentLoaded', () => {
  theme.alinga.brandWithText();
  theme.alinga.footer();
  theme.alinga.custTestimonialSlider();
  theme.alinga.homepageBannerSlider();
  theme.alinga.productBlockATC();
  theme.alinga.custBundleSection();
  theme.alinga.pdpDeskGallery();
  theme.alinga.threeDGallery();
  theme.alinga.shadePopupData();
  theme.alinga.productGallery();
  theme.alinga.equalHeight('.product-block .shade-swaches.block-swatches');
  theme.alinga.equalHeight('.product--block.product-block .title');
  theme.alinga.equalHeightpdp('.product-block .shade-swaches.block-swatches');
  theme.alinga.equalHeightpdp('.product--block.product-block .title');
  theme.alinga.shadepopv2slider();
  theme.alinga.mobilemenu();
  theme.alinga.readMoreLess();
});

